// Generated by https://quicktype.io

export class FocusPayPreApp {
	BusinessInformation: BusinessInformation;
	Entry: Entry;
	HowManyOwnersWithAtLeast20InterestInTheBusiness: string;
	$etag: string;
	Form: Form;
	merchantLegalName: string;
	$version: number;
	AboutYourEstablishment: AboutYourEstablishment;
	OwnershipInformation: OwnershipInformation;
	sk: string;
	pk: string;
	Id: string;
	deleted: boolean;
	status: ApplicationStatus;
	activityHistory: PreAppActivityHistory[] = [];

	public constructor(init?: Partial<FocusPayPreApp>) {
		Object.assign(this, init);
	}
}

export class PreAppActivityHistory {
	user: string;
	originalStatus: string;
	newStatus: string;
	dateTime: string;

	public constructor(init?: Partial<PreAppActivityHistory>) {
		Object.assign(this, init);
	}
}

export interface AboutYourEstablishment {
	HighestMonthlyCCVolume: number;
	HighestCheck: number;
	AverageCheckAmount_IncrementBy: number;
	QuantityOfTransactions_IncrementBy: number;
	QuantityOfTransactions: number;
	HighestMonthlyCCVolume_Minimum: number;
	HighestMonthlyCCVolume_Maximum: number;
	HighestCheck_IncrementBy: number;
	TypeOfEstablishment: string;
	AverageCheckAmount: number;
	HighestMonthlyCCVolume_IncrementBy: number;
}

export interface BusinessInformation {
	BusinessTaxIDEIN: string;
	VoidedCheckOrBankLetter: VoidedCheckOrBankLetter[];
	LegalBusinessName: string;
	BusinessEmailAddress: string;
	BusinessPhone: string;
	BusinessPhysicalAddress: Address;
	PrimaryContactBusinessManager: string;
	MerchantDba: string;
}

export interface Address {
	FullAddress: string;
	StreetAddress: string;
	Type: string;
	CityStatePostalCode: string;
	State: string;
	Country: string;
	FullInternationalAddress: string;
	PostalCode: string;
	City: string;
	Line1: string;
}

export interface VoidedCheckOrBankLetter {
	Id: string;
	ContentType: string;
	IsEncrypted: boolean;
	File: string;
	Size: number;
	Name: string;
}

export interface Entry {
	Origin: Origin;
	Status: string;
	ViewLink: string;
	DateUpdated: string;
	DateCreated: string;
	Timestamp: string;
	Number: number;
	AdminLink: string;
	Version: number;
	EditLink: string;
	Document2: string;
	Document1: string;
	DateSubmitted: string;
	IsBeta: boolean;
}

export interface Origin {
	UserAgent: string;
	IpAddress: string;
	IsImported: boolean;
}

export interface Form {
	InternalName: string;
	Id: string;
	Name: string;
}

export interface OwnershipInformation {
	Owner2: Owner;
	Owner5: Owner;
	Owner1: Owner;
	Owner4: Owner;
	Owner3: Owner;
}

export interface Owner {
	HomeAddress: Address;
	Ownership: number;
	Email: string;
	SocialSecurity: string;
	Ownership_IncrementBy: number;
	Phone: string;
	DriversLicense: VoidedCheckOrBankLetter[];
	Name: string;
}

export enum ApplicationStatus {
	RECEIVED = 'received', //#2d90fa
	INREVIEW = 'in review', //#2d3bfa
	APPLICATIONSENT = 'application sent', //#2dfa86
	APPLICATIONOUTFORSIGNATURE = 'application out for signature',
	VERIFYINGDOCUMENTS = 'verifying documents',
	UNDERWRITING = 'in underwriting',
	APPROVED = 'approved',
	DECLINED = 'declined',
	BOARDED = 'boarded',
	PROCESSING = 'processing',
}
